import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { adminGuard } from './commons/guard/admin.guard';
import {HomeComponent} from './components/home-component/home-component';
import {AccessDeniedComponent} from './components/access-denied/access-denied.component';

export const routes: Routes = [
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard, adminGuard]
  }
];
